import axios from "@/libs/phpAxios"

// 开关店
export const toggleMerchantStatus = () => {
  return axios.request({
    method: "POST",
    url: "merch/site/suspend-business",
  })
}

// 自动接单设置
export const changeAutoAcceptOrder = () => {
  return axios.request({
    method: "POST",
    url: "merch/site/auto-accept-order",
  })
}

// 自动ready订单
export const changeAutoReadyOrder = () => {
  return axios.request({
    method: "POST",
    url: "merch/site/auto-mark-order-to-ready",
  })
}

// 是否接收大IM消息
export const changeReceiveMessages = () => {
  return axios.request({
    method: "POST",
    url: "merch/site/willing-to-receive-notification",
  })
}

// 商家手动设置 Estimated pickup time
export const changeMerchDecideConfirmedTime = () => {
  return axios.request({
    method: "POST",
    url: "/merch/site/merch-decide-confirmed-time",
  })
}

// 设置是否开启打印功能
export const changePrintingStatus = () => {
  return axios.request({
    method: "POST",
    url: "/merch/site/switch-print",
  })
}
